import { render, staticRenderFns } from "./TransactionVolumesModal.vue?vue&type=template&id=2d6947b2&scoped=true"
import script from "./TransactionVolumesModal.vue?vue&type=script&lang=js"
export * from "./TransactionVolumesModal.vue?vue&type=script&lang=js"
import style0 from "./TransactionVolumesModal.vue?vue&type=style&index=0&id=2d6947b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6947b2",
  null
  
)

export default component.exports